import { render, staticRenderFns } from "./dialog-multimovefile.vue?vue&type=template&id=3b1e83d4&"
import script from "./dialog-multimovefile.vue?vue&type=script&lang=js&"
export * from "./dialog-multimovefile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports